
import {defineComponent} from "vue";
import {_cmsStore} from "@/stores/cmsStore";
import sanitizeHtml from "@/modules/sanitizeHtml";

interface legalLink{
  url: string,
  title: string
}

export default defineComponent({
  name: "FooterMod",
  components: {},
  emits: ["openCookies"],
  data() {
    return{
      conduct: {} as legalLink,
      legalLinks: [] as Array<legalLink>,
      // transparency note HTML from iconomy_footer (empty = use template fallback)
      registerInfo: ""
    }
  },
  mounted(){
    this.requestLegal();
    this.requestFooter();
  },
  methods: {
    async requestFooter(){
      const cms = await _cmsStore.instance();
      cms.request("iconomy_footer", false, {})
      .then((response) => {
        // CMS rich text reaches v-html — sanitize the HTML before binding
        this.registerInfo = (response && response.registerInfo) ? sanitizeHtml(response.registerInfo) : "";
      }).catch((err) => {console.log(err)});
    },
    async requestLegal(){
      const cms = await _cmsStore.instance();
      cms.request("iconomy_legal", true, {
        select: ["url", "page_title"]
      })
      .then((response) => {
        this.structLegal(response.entries);
      }).catch((err) => {console.log(err)});
    },
    structLegal(cmsData:any){
      for(let x in cmsData){
        if(cmsData[x]._id === "6367f425396661244c000305") this.conduct = {
          title:cmsData[x].page_title, url:"/legal/"+cmsData[x].url
        };
        else this.legalLinks.push({
          title: cmsData[x].page_title,
          url: "/legal/"+cmsData[x].url
        });
      }
    }
  }
});
